import { render, staticRenderFns } from "./YearlyRatios.vue?vue&type=template&id=1c85390e"
import script from "./YearlyRatios.vue?vue&type=script&lang=js"
export * from "./YearlyRatios.vue?vue&type=script&lang=js"
import style0 from "./YearlyRatios.vue?vue&type=style&index=0&id=1c85390e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports